import * as React from "react";
import { forwardRef } from "react";
const SvgWarningFilled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "#DD3D45", viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 1.25c-4.813 0-8.75 3.938-8.75 8.75 0 4.813 3.938 8.75 8.75 8.75 4.813 0 8.75-3.938 8.75-8.75 0-4.813-3.938-8.75-8.75-8.75zM9.312 5h1.376v6.875H9.312V5zM10 15.625c-.5 0-.938-.438-.938-.938 0-.5.438-.937.938-.937.5 0 .938.438.938.938 0 .5-.438.937-.938.937z" }));
const ForwardRef = forwardRef(SvgWarningFilled);
export { ForwardRef as ReactComponent };
